import { setQuery } from "./actions"

const extraReducers = {
  [setQuery.fulfilled]: (state, action) => {
    state.query = action.payload
  },
}

export default extraReducers
